// extracted by mini-css-extract-plugin
export default {"wrapperInner":"wrapperInner--rfCbm","root":"root--KRlbi","collapseContainer":"collapseContainer--WbcfY","note":"note--GzJqk"};